<div
  capraTooltip
  [tooltipContent]="((googleSheetsEnabled$ | async) ? 'Disable' : 'Enable') + ' Google Sheets integration for the Workspace'"
  tooltipPlacement="left"
  size="medium"
>
  <mode-toggle-switch
    [state]="googleSheetsEnabled$ | async"
    (stateChange)="toggleGoogleSheetsSetting($event)"
  ></mode-toggle-switch>
</div>
